import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type PageToolbarContainerProps = ComponentProps<'div'>;

function PageToolbarContainer({ className, children, ...props }: PageToolbarContainerProps) {
  return (
    <div className={twMerge('-top-12 md:top-(--sticky-primary-header-height,0px)', className)} {...props} id="page-toolbar">
      {children}
    </div>
  );
}

export { PageToolbarContainer };
